import { HTTP } from "@/api";

export default {
  login({ commit, dispatch }, { email, password }) {
    return new Promise((resolve, reject) => {
      const validate = loginDataValidate(email, password);
      if (validate !== true) {
        reject(validate);
        return;
      }
      HTTP.post("/v2/auth/admin/login", { email, password })
        .then((res) => {
          let data = res.data;
          if (data && data.success) {
            commit("login", {
              user: data.user,
            });
          } else reject("Login failed!");
        })
        .catch(reject);
    });
  },
  logout({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        HTTP.get("/v2/auth/admin/logout")
          .then((res) => {
            let data = res.data;
            if (data && data.success) {
              commit("logout");
            } else reject("Logout failed!");
          })
          .catch(reject);
        resolve(false);
      } catch (e) {
        reject(e);
      }
    });
  },
  session({ commit, dispatch }) {
    return new Promise(async (resolve, reject) => {
      try {
        HTTP.get("/v2/admin/init")
          .then((res) => {
            let data = res.data;
            if (data && data.success) {
              commit("login", {
                user: data.user,
              });
            } else reject("Login failed!");
          })
          .catch(reject);
        resolve(false);
      } catch (e) {
        reject(e);
      } finally {
        ["live statistic", "filters", "filter settings"].forEach((key) => {
          commit("isLoading", {
            key,
            status: false,
          });
        });
      }
    });
  },
  checkSession({ dispatch, state }) {
    if (!window.$cookies.isKey("session")) {
      dispatch("logout");
      return false;
    }
    const date = +new Date();
    const c = window.$cookies.get("session");
    if (c.session.expiresIn <= date) {
      dispatch("logout");
      return false;
    }
    const time = state.sessionNotificationTime;
    const left = (c.session.expiresIn - date) / 1000 / 60;
    if (left <= time) return Math.ceil(left);
    return true;
  },
  restartApp() {
    return HTTP.post("/app_restart").then((res) => {
      return res.data.success ? "Restarting..." : `Error: ${res.data.error}`;
    });
  },
};

function loginDataValidate(email, password) {
  if (!email) return "E-mail not specified";
  const pattern =
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  if (!pattern.test(email)) return "Wrong e-mail format";
  if (!password) return "Password not specified";
  return true;
}

let hiddenTabTimer = false;
const MAX_HIDDEN_TIME = 3 * 60 * 1000;

document.addEventListener("visibilitychange", async function () {
  if (document.hidden) {
    hiddenTabTimer = setTimeout(() => {
      // socket.destroy();
      hiddenTabTimer = false;
    }, MAX_HIDDEN_TIME);
  } else {
    if (hiddenTabTimer) clearTimeout(hiddenTabTimer);
    else {
    }
  }
});
